/*
 * pic-nn-web-ui
 *
 * Web UI for neural network applications.
 *
 * @copyright 2020 VSTE CB <http://www.vstecb.cz/>.
 * @license See LICENSE file distributed with this source code for more information.
 */

import React from "react";
import { InputWrapper, IInputCommonProps } from "./InputWrapper";
import { ModelInputOptions } from "../../shared/model/inputs/ModelInputOptions";

/**
 * Component props
 */
export interface IInputOptionsProps extends IInputCommonProps {
	/** Input field */
	input: ModelInputOptions<any>;

	/** Input options */
	options?: Array<{
		value: string;
		label: string;
	}>;
}

/**
 * Options field component
 *
 * @param props Props
 */
export function InputOptions(props: IInputOptionsProps) {

	const handleChange = (ev) => {
		props.input.set(ev.target.value);
	};

	return <InputWrapper {...props} render={(state, baseStyle) => {
		const options = props.options || state.config.optionLabels || [];

		return <>
			<select onChange={handleChange} value={state.inputValue}>
				{options.map((item, index) => {
					return <option key={index} value={item.value}>{item.label}</option>;
				})}
			</select>
		</>;
	}} />;

}
